import MyLicense from './MyLicense';

export default {
  MyLicense,
};
